import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminParceiro: Routes = [
  {
    path: 'atendentes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_ATENDENTE',
      breadcrumb: {
        label: 'Atendentes',
        icon: 'mdi mdi-domain'
      },
      backend_path: '/atendentes'
    },
    loadChildren: () =>
      import('@app/modules/atendente/atendente.module').then(
        m => m.AtendenteModule
      )
  },
  {
    path: 'profissionais',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_PROFISSIONAL',
      breadcrumb: {
        label: 'Profissionais',
        icon: 'mdi mdi-domain'
      },
      backend_path: '/profissionais'
    },
    loadChildren: () =>
      import('@app/modules/profissional/profissional.module').then(
        m => m.ProfissionalModule
      )
  },
  {
    path: 'pacientes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_PACIENTE',
      breadcrumb: {
        label: 'Pacientes',
        icon: 'mdi mdi-domain'
      },
      backend_path: '/pacientes'
    },
    loadChildren: () =>
      import('@app/modules/paciente/paciente.module').then(
        m => m.PacienteModule
      )
  },
  {
    path: 'fornecedores',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_FONECEDOR',
      breadcrumb: {
        label: 'Fornecedores',
        icon: 'mdi mdi-domain'
      },
      backend_path: '/fornecedores'
    },
    loadChildren: () =>
      import('@app/modules/fornecedor/fornecedor.module').then(
        m => m.FornecedorModule
      )
  }
];
